import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { LazyLoadDirective } from '@bn/web-ui';
import { ButtonComponent } from '@bn/web-ui/button/button.component';
import { CardComponent } from '@bn/web-ui/card/card.component';
import { ListWithIconItem } from '@bn/web-ui/premium-banner';
import { ListWithIconComponent } from '@bn/web-ui/premium-banner/list-with-icon/list-with-icon.component';

@Component({
  selector: 'app-shield-setup-start',
  templateUrl: './app-shield-setup-start.component.html',
  styleUrls: ['./app-shield-setup-start.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, CardComponent, ListWithIconComponent, LazyLoadDirective],
})
export class AppShieldSetupStartComponent {
  public readonly setupClick = output<void>();

  public readonly featuresListItems: ListWithIconItem[] = [
    {
      icon: 'circle-check',
      text: '<strong>WAF learning mode:</strong> Eliminate false positives!',
    },
    {
      icon: 'circle-check',
      text: '<strong>OWASP top 10 included:</strong> Comprehensive protection for all!',
    },
    {
      icon: 'circle-check',
      text: '<strong>Advanced website DDoS mitigation:</strong> Stay online, always.',
    },
    {
      icon: 'circle-check',
      text: '<strong>Global rate limiting:</strong> We keep track, globally.',
    },
    {
      icon: 'circle-check',
      text: '<strong>Custom WAF rules:</strong> Security tailored to you!',
    },
  ];

  public onSetupClick(): void {
    // TODO: The 'emit' function requires a mandatory void argument
    this.setupClick.emit();
  }
}
